import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';

const SERVICE_PATH = /^\/szolgaltatas\//;

export default function ServiceFloatingQuoteCta() {
  const location = useLocation();
  const { t } = useI18n();
  const [visible, setVisible] = React.useState(false);
  const [targetHref, setTargetHref] = React.useState('/ajanlat');

  const isServicePage = SERVICE_PATH.test(location.pathname);

  React.useLayoutEffect(() => {
    if (!isServicePage) {
      setVisible(false);
      return undefined;
    }

    const el = document.querySelector('.svc-hero-cta');
    if (!el) {
      return undefined;
    }

    const href = el.getAttribute('href');
    if (href) {
      setTargetHref(href);
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: '0px' },
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [location.pathname, isServicePage]);

  if (!isServicePage || !visible) {
    return null;
  }

  const external = /^https?:\/\//i.test(targetHref);

  return (
    <div className="svc-floating-quote">
      {external ? (
        <a className="primary-btn svc-floating-quote-btn" href={targetHref} rel="noopener noreferrer">
          {t('nav_quote')}
        </a>
      ) : (
        <Link className="primary-btn svc-floating-quote-btn" to={targetHref}>
          {t('nav_quote')}
        </Link>
      )}
    </div>
  );
}
